
export enum ExportStatus {
    Processing = 0,
    Expired = 1,
    Error = 2,
    Completed = 3
}
export interface IExportDataRequestData {
    exportDataRequestID: number,
    exportStatus: ExportStatus,
    exportTypeDescription: string,
    exportDescription: string,
    fileName: string,
    expirationTime: string,
    postDate: string
    userMessage?: string,
    downLoadCount: number
};
export interface IExportDataResponse {
    errorCode: number,
    errorMessage: string 
}
export interface IExportDataInput {
    ExportDataRequestID: number,
}
export interface IDownLoadInput {
    ExportDataRequestID: number,
    SheetName: string 
}
export interface IExportDataRequestDataMessageBadgeItem {
    tooltip: string,
    overrideStyle: string,
    display: string
}
export interface ITableSearchResponse {
    export_data_request_id: number,
    successful: boolean,
    excelDataStream?: Uint8Array,
    responseMessage: string
}
